/* eslint-disable @typescript-eslint/no-namespace */
import { type CustomServiceDefinition } from "./CustomServiceDefinition";
import type { ServiceDefinition } from "./ServiceDefinition";

export type ServiceDefinitionTemplate = Pick<ServiceDefinition, "name" | "description" | "actionLabel"> & {
    serviceId: CustomServiceDefinition.Id | ServiceDefinition.Id;
    serverUrl: string;
};

export namespace ServiceDefinitionTemplate {
    /**
     * Creates a new service definition template.
     *
     * @param service The service definition to create the template for.
     * @param applicationActionUrl The application action url to use.
     * @returns The service definition template.
     */
    export const create = (
        service: ServiceDefinition | CustomServiceDefinition,
        applicationActionUrl: string
    ): ServiceDefinitionTemplate => {
        const { id, name } = service;

        if (!id) {
            throw new Error("ServiceDefinitionTemplate: Property 'id' cannot be empty.");
        }

        if (!name) {
            throw new Error("ServiceDefinitionTemplate: Property 'name' cannot be empty.");
        }

        if (!applicationActionUrl) {
            throw new Error("ServiceDefinitionTemplate: Property 'applicationActionUrl' cannot be empty.");
        }

        return {
            serviceId: id,
            name,
            description: service.description,
            actionLabel: service.actionLabel,
            serverUrl: applicationActionUrl,
        };
    };
}
